var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"bread-crumbs"},[_c('app-bread-crumbs',{attrs:{"routes":[
          { name: 'adminHome', title: 'Administration' },
          { name: 'adminUsers', title: 'Gestion de site' },
          { name: 'adminUserEditPage', title: 'Modification d\'un compte utilisateur' }
        ]}}),_c('b-row',[_c('b-col',[_c('h1',{staticClass:"uppercase page-title"},[_vm._v("Modifier un compte utilisateur")]),_c('form-admin-user-edit-account')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }